import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SystemStateMonitor.html?raw';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { ToasterHelpers, TranslationHelpers } from "../../more/Helpers";


interface settingsModule {
    pingMaxResponseTimeout: number,
    requestTimeoutPreWarning: number,
    requestTimeoutWarning: number,
    pingInterval: number
}

interface sessionDebugInfo {
    MaxPitSessionCount: number;
    MaxPitSessionsPerUser: number;
    MyPitSessionCount: number;
    SessionsTotal: number;
    WebSessionsTotal: number;
}

interface RequestDurationWarningData {
    id: number,
    requestname: string
    complete: boolean
}
type Problem = "ping" | "requestduration" | "windowoffline";
class SystemStateMonitor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private _disabled: boolean = false;

    private currentProblems: Array<Problem> = [];

    private txtBrowserOfflineMessage: HTMLElement;
    private txtServerOfflineMessage: HTMLElement;

    private offlineIndicatorContainer: HTMLElement;
    private offlineIndicator_btnRetryPing: HTMLElement;
    private offlineIndicator_btnReloadPage: HTMLElement;
    private offlineIndicator_ButtonsContainer: HTMLElement;
    private offlineIndicator_ResponseMessage: HTMLElement;
    private iconRetryPingSuccess: HTMLElement;

    private requestDurationContainer: HTMLElement;
    private requestDuration_DefaultMessage: HTMLElement;
    private requestDuration_ResponseMessage: HTMLElement;
    private requestDuration_ButtonsContainer: HTMLElement;

    private _devDebugEnabled: boolean = false;

    //private showOfflineIndicator() {
    //    this.addProblem("ping");
    //}

    private _currentRequestDurationWarnings: Array<RequestDurationWarningData>

    private showRequestDurationWarning(data: RequestDurationWarningData) {

        
        // alles raus, was schon complete ist
        let remainingData = this._currentRequestDurationWarnings.filter(elem => {
            return elem.complete != true;
        });

        this._currentRequestDurationWarnings = remainingData;

        let existingIndex = -1;
        for (let i = 0; i < this._currentRequestDurationWarnings.length; i++) {
            let registered = this._currentRequestDurationWarnings[i];
            if (registered.id == data?.id) {
                existingIndex = i;
                break;
            }
        }


        if (data && existingIndex == -1 && data.complete != true) {
            this._currentRequestDurationWarnings.push(data);
        } else if (existingIndex != -1) {
            this._currentRequestDurationWarnings.splice(existingIndex, 1);
        }

        if (this._currentRequestDurationWarnings.length > 0) {
            let messages = this._currentRequestDurationWarnings.map((data) => { return data.requestname; })
            let message = messages.join("</br>");
            this._initOverlay();
            this.hideNode(this.requestDurationContainer, false);

            this.UiModder.domAttr.set(this.requestDuration_DefaultMessage, "innerHTML", this.translate("RequestDurationWarning_Message"));
            this.UiModder.domAttr.set(this.requestDuration_ResponseMessage, "innerHTML", message ? message : "");
            this.hideNode(this.requestDuration_ResponseMessage, !message);

            this.execPing();

            this.addProblem("requestduration");
        } else {
            this.resolveProblem("requestduration");
        }
    }
    
    private _onClick_RetryPing(evt: MouseEvent) {
        this.__pingResponsesCount = this.pingResponsesNeededAfterFailure - 1;
        this.execPing();
    }
    private _onClick_Reload(evt: MouseEvent) {
        location.reload();
    }

    private _onDevPrivilege(bPrivilege: boolean) {
        if (this.hasFeature("systemstatemonitor/showDevDebugToasts") && this.hasUserRole("_DEV")) {
            this._devDebugEnabled = true;
        }
    }

    private pingIntervalSeconds: number = 30;
    private pingIntervalSecondsAfterFail: number = 5;
    private pingMaxResponseTimeoutSeconds: number = 15;
    private pingResponsesNeededAfterFailure: number = 1; // so viele Pings müssen funktionieren, damit der Hinweis wieder verschwindet
    private __pingResponsesCount: number = 0; // aktueller Zähler von erfolgreichen pings mit Response. Wird auf 0 gesetzt bei Fehler oder no response
    private __pingResponseTimeout; // timeout, das parallel zum Request abläuft
    private __pingExecTimeout; //
    private __lastPingResponse: Date;
    private _lastPingResponse: string;
    private pingResponseInfo: HTMLElement;
    private __nextPingExec: Date;
    private execPing() {
        if (this._disabled) return;

        if (this.hasFeature("systemstatemonitor/disableOfflinePing")) {
            return;
        }
        if (this.__pingExecTimeout) clearTimeout(this.__pingExecTimeout);

        this.disableNode(this.offlineIndicator_ButtonsContainer);
        // gleichzeitig Timeout starten:
        if (this.__pingResponseTimeout) clearTimeout(this.__pingResponseTimeout);
        // sofern wir gerade nicht im "Fehlermodus laufen"... (ping-response-count wird negativ wenn offline)
        if (this.__pingResponsesCount > 0) {
            this.__pingResponseTimeout = setTimeout(lang.hitch(this, this._onPingNoResponse), this.pingMaxResponseTimeoutSeconds * 1000);
        }

        let enableDebuginfo = !this.hasFeature("systemstatemonitor/disablePitSessionState");

        this.__nextPingExec = null;

        this.RequestManager.post(
            window.appRoot + "Session/Ping",
            {
                //"sleep": 0 // für DEV-tests zb auf 8s stellen
                "sessionDebugInfo": enableDebuginfo
            },
            lang.hitch(this, this._onPingResponse),
            lang.hitch(this, this._onPingError));

    }
    private _onPingNoResponse() {

        if (this.__pingResponseTimeout) clearTimeout(this.__pingResponseTimeout);

        this.hideNode(this.iconRetryPingSuccess);
        this.disableNode(this.offlineIndicator_ButtonsContainer, false);
        this.__nextPingExec = null;

        if (navigator.onLine === false) {
            this.addProblem("windowoffline");
        }

        // keine Rückmeldung? dann auf 0 resetten und nach unten zählen:
        if (this.__pingResponsesCount >= 0) {
            this.__pingResponsesCount = 0;
        }
        this.__pingResponsesCount--;

        if (this._devDebugEnabled) {
            this.showToast({
                title: "Ping: No response " + this.__pingResponsesCount,
                iconClass: "fas fa-cogs",
                showClose: true,
                timeout:3000
            });
        }

        // nach mehreren Fehlschlägen zeigen wir den Indikator:
        if (this.__pingResponsesCount <= -3) {
            //this.showOfflineIndicator();
            this.addProblem("ping");
        }
        this.__pingExecTimeout = setTimeout(lang.hitch(this, this.execPing), this.pingIntervalSecondsAfterFail * 1000);
    }
    private _onPingResponse(response) {

        if (window.translations) ToasterHelpers.removeToast("noTranslationsOffline");

        this.__nextPingExec = null;

        if (navigator.onLine === true) {
            this._onWindowOnline(null);
        }
        
        if (typeof (response) == "object" && response != null) {
            if (this.hasUserRole("_DEV")) {
                console.debug(new Date().toLocaleTimeString(), this.id + " ping response", response, "response count old: " + this.__pingResponsesCount);
            }

            
            let data = response as sessionDebugInfo;
            if (data) {
                //if (data.MaxPitSessionsPerUser <= data.MyPitSessionCount && data.MyPitSessionCount) {
                //    this.UiModder.domAttr.set(this.pingResponseInfo, "innerHTML", this.translate("PitSessionCountExceeded"));
                //} else if (data.MaxPitSessionCount <= data.SessionsTotal && data.SessionsTotal) {
                //    this.UiModder.domAttr.set(this.pingResponseInfo, "innerHTML", this.translate("PitTotalSessionCountExceeded"));
                //} else {
                //    this.UiModder.domAttr.set(this.pingResponseInfo, "innerHTML", JSON.stringify(data));
                //}

                this.UiModder.domAttr.set(this.pingResponseInfo, "innerHTML", JSON.stringify(data));

                this.hideNode(this.pingResponseInfo);
            } else {
                this.UiModder.domConstruct.empty(this.pingResponseInfo);
                this.hideNode(this.pingResponseInfo);
            }


        }
        if (typeof(response) == "string") {
            this._lastPingResponse = response;

            try {
                let data = JSON.parse(response);
                this._onPingResponse(data);
                return;
            } catch (ex) {

            }

            this.UiModder.domAttr.set(this.pingResponseInfo, "innerHTML", response);
        }

        if (this.__pingResponsesCount < 0) this.__pingResponsesCount = 0;
        else this.__pingResponsesCount++;

        if (this._devDebugEnabled && this.__pingResponsesCount <= this.pingResponsesNeededAfterFailure) {
            this.showToast({
                title: "Ping: Response " + this.__pingResponsesCount,
                iconClass: "fas fa-cogs w3-text-green",
                showClose: true,
                timeout: 3000
            });
        }


        this.__lastPingResponse = new Date();

        this.disableNode(this.offlineIndicator_ButtonsContainer, false);

        if (this.__pingResponseTimeout) clearTimeout(this.__pingResponseTimeout);

        if (this.__pingResponsesCount >= this.pingResponsesNeededAfterFailure) {
            
            this.hideNode(this.iconRetryPingSuccess, false);

            this.resolveProblem("ping");
            this.hideNode(this.offlineIndicator_ResponseMessage);
        }

        if (this.__pingExecTimeout) clearTimeout(this.__pingExecTimeout);

        let targetInterval = this.pingIntervalSeconds * 1000;
        if (this.__pingResponsesCount < this.pingResponsesNeededAfterFailure && this.__pingResponsesCount <= 0) {
            targetInterval = this.pingIntervalSecondsAfterFail * 1000;
        }

        this.__pingExecTimeout = setTimeout(lang.hitch(this, this.execPing), targetInterval);
        let nextDate = new Date();
        nextDate = new Date(nextDate.getTime() + targetInterval);
        this.__nextPingExec = nextDate;
    }

    private _onPingError(error: more.requestErrorMessage) {
        // error kann auch sein wenn man wirklich offline ist
        this._onPingNoResponse();
    //    if (this.__pingRequestTimeout) clearTimeout(this.__pingRequestTimeout);

    //    this.disableNode(this.offlineIndicator_ButtonsContainer, false);
    //    this.hideNode(this.iconRetryPingSuccess, false);

    //    this.__pingResponsesCount = 0;
    //    this.showOfflineIndicator();

    //    this.hideNode(this.offlineIndicator_ResponseMessage, !error?.Message);
    //    this.UiModder.domAttr.set(this.offlineIndicator_ResponseMessage, "innerHTML", error?.Message);

    //    this.__pingExecTimeout = setTimeout(lang.hitch(this, this.execPing), this.pingIntervalSecondsAfterFail * 1000 );
    }

    private _onWindowOffline(evt: Event) {
        
        //this.addProblem("windowoffline")
        if (navigator.onLine === true) return; // ne. passt doch.


        //ToasterHelpers.showToast({
        //    title: TranslationHelpers.tryTranslate("OfflineIndicator_StatusChangedToOffline", false, "device offline"),
        //    iconClass: "fas fa-network-wired w3-text-red",
        //    ID: "windowOffline",
        //    timeout: "permanent"
        //});

        // erst mal keine Panik, aber einen Ping rausschicken und schaun ob sich das bewahrheitet:
        this.execPing();

    }

    private _onWindowOnline(evt: Event) {

        this.resolveProblem("windowoffline");

        //ToasterHelpers.showToast({
        //    title: TranslationHelpers.tryTranslate("OfflineIndicator_StatusChangedToOnline", false, ""),
        //    iconClass: "fas fa-network-wired w3-text-green",
        //    ID: "windowOffline",
        //    timeout:5000
        //});

    }
    
    private _initOverlay() {

        if (this._disabled) return;

        this.UiModder.domConstruct.place(this.domNode, document.body);

        this.hideNode(this.domNode, false);

    }
    private addProblem(problem: Problem) {
        let index = this.currentProblems.indexOf(problem);
        if (index == -1) {
            this.currentProblems.push(problem);
            this._initOverlay();

            switch (problem) {
                case "windowoffline":
                    // wird nicht genutzt - ping erledigt die richtige Prüfung
                    this.hideNode(this.offlineIndicatorContainer, false);
                    this.hideNode(this.txtBrowserOfflineMessage, false);
                    this.UiModder.domClass.add(document.body, "offline");
                    break;
                case "ping":
                    this.hideNode(this.offlineIndicatorContainer, false);
                    this.hideNode(this.txtServerOfflineMessage, navigator.onLine);
                    this.hideNode(this.pingResponseInfo); // bringt ja nix, ohne ping gibts auch keine Infos.
                    this.UiModder.domClass.add(document.body, "noPing");
                    break;
                case "requestduration":
                    this.hideNode(this.requestDurationContainer, false);
                    break;
            }
        }
    }
    private resolveProblem(problem: Problem, delay: number = 1000) {
        let index = this.currentProblems.indexOf(problem);
        if (index != -1) this.currentProblems.splice(index, 1);

        if (typeof (delay) != "number" || delay < 0) {
            delay = 100;
        }

        switch (problem) {
            case "windowoffline":
                //setTimeout(lang.hitch(this, this.hideNode, this.networkOfflineContainer), delay);
                this.UiModder.domClass.remove(document.body, "offline");
                setTimeout(lang.hitch(this, this.hideNode, this.txtBrowserOfflineMessage), delay);
                break;
            case "ping":
                setTimeout(lang.hitch(this, this.hideNode, this.offlineIndicatorContainer), delay);
                setTimeout(lang.hitch(this, this.hideNode, this.txtServerOfflineMessage), delay);
                this.UiModder.domClass.remove(document.body, "noPing");
                break;
            case "requestduration":
                setTimeout(lang.hitch(this, this.hideNode, this.requestDurationContainer), delay);
                break;
        }

        if (this.currentProblems.length == 0) this.hideOverlay(delay);
    }
    private hideOverlay(delay?: number) {
        if (typeof (delay) != "number" || delay < 0) {
            delay = 100;
        }
        setTimeout(lang.hitch(this, this.hideNode, this.domNode), delay);
        setTimeout(lang.hitch(this, this.hideNode, this.offlineIndicatorContainer), delay);
        setTimeout(lang.hitch(this, this.hideNode, this.requestDurationContainer), delay);
    }

    private _onVisibilityChanged(evt) {
        // Tab oder Browserfenster wieder aktiv
        if (this._disabled) return;

        // letzter ping-Request zu lange her?
        if (this.__lastPingResponse && this.__nextPingExec) {
            let now = new Date();
            if (now.valueOf() > this.__nextPingExec.valueOf()) {
                if (this.__pingExecTimeout) clearTimeout(this.__pingExecTimeout);
                this.execPing();
            }
        }
    }

    private _onRequestDurationWarning(data: RequestDurationWarningData) {
        this.showRequestDurationWarning(data);
    }
    private _onRequestDurationPreWarning(data: RequestDurationWarningData) {

        // VORwarnung - der Request dauert etwas lange, besser mal gucken ob noch alles im Lot ist. vielleicht sind ja Sessions alle voll.
        // jetzt müssten wir einen ping ausführen um die Debuginfos zu bekommen und die dann extra auswerten, damit wir ggf. reagieren können
        // weil OFFLINE muss das Webtool ja nicht sein, es kann einfach nicht reagieren weil pit ausgelastet ist.

        if (this._devDebugEnabled) {
            if (data) {
                this.showToast({
                    title: "Request Dauer - Vorwarnung",
                    message: JSON.stringify(data),
                    timeout: 8000,
                    showClose: true
                });
            }
        }
    }

    postCreate() {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.silentExceptions = true;

        this.currentProblems = [];

        this._disabled = !this.hasModuleVersion("SystemStateMonitor") || this.hasFeature("SystemStateMonitor/disableAllMonitoring");
        this._currentRequestDurationWarnings = [];

        if (!this._disabled) {
            this.addSubscription("/Global/VisibilityChange", lang.hitch(this, this._onVisibilityChanged));

            if (!this.hasFeature("SystemStateMonitor/disableRequestDurationWarning")) {
                this.addSubscription("/Requestmanager/DurationWarning", lang.hitch(this, this._onRequestDurationWarning));
                this.addSubscription("/Requestmanager/DurationWarning/Pre", lang.hitch(this, this._onRequestDurationPreWarning));
            }

            let moduleSettings = this.getModule<Partial<settingsModule>>("SystemStateMonitor");

            if (moduleSettings) {
                if (moduleSettings.pingInterval >= 5) {
                    this.pingIntervalSeconds = moduleSettings.pingInterval;
                }

                if (moduleSettings.pingMaxResponseTimeout >= 5) {
                    this.pingMaxResponseTimeoutSeconds = moduleSettings.pingMaxResponseTimeout; 
                }
            }

            addEventListener("offline", lang.hitch(this, this._onWindowOffline));
            addEventListener("online", lang.hitch(this, this._onWindowOnline));
        }

    }

    //_simulateOffline() {
    //    this._onWindowOffline(null);
    //}

    //_simulateOnline() {
    //    this._onWindowOnline(null);
    //}

   
    startup() {
        super.startup.apply(this, arguments as any);

        if (!this._disabled) {
            this.__pingExecTimeout = setTimeout(lang.hitch(this, this.execPing), 5000);

            if (!this.hasFeature("SystemStateMonitor/disableTranslationsBasedOfflineWarning")) {
                if (!window.translations || window.translations.hasOwnProperty("MainTitle") != true) {
                    // nur wenn wir nicht generell offline sind:
                    if (this.currentProblems.indexOf("windowoffline") == -1) {
                        ToasterHelpers.showToast({
                            ID: "noTranslationsOffline",
                            title: TranslationHelpers.tryTranslate("OfflineIndicator_NoTranslations_Title", false, "No connection to the server"),
                            iconClass: "fas fa-network-wired w3-text-red",
                            timeout: "permanent"
                        })
                    }
                }
            }
        }

        this.hasUserRole("_DEV", lang.hitch(this, this._onDevPrivilege));

    }
}

export default mdsWidget(SystemStateMonitor);